module.exports = __webpack_public_path__ + "media/description/description@1x-04f882dc.png";